import Input from './Input';
import Button from './Button';
var Controls = {
    Input: Input,
    Button: Button,
};
export default Controls;
//# sourceMappingURL=Controls.js.map